import {
  Design,
  DesignModule,
  DesignModuleLocalVariable,
  DesignVariable,
  Option,
  VariableReference,
  VariableReferenceScope,
  VariableScope,
  VariableType,
  VariableValue
} from '@app/types';

export type VariableOption = (
  Option<VariableReference>
  & {
    defaultValue: VariableValue;
    item: DesignVariable | DesignModuleLocalVariable;
    sensitiveData: boolean;
    scope: VariableReferenceScope;
    type: VariableType;
  }
);

export type GetVariablesProps = {
  serialized?: Design;
  serializedModule?: DesignModule | null;
  searchScopes?: VariableReferenceScope[];
  searchTypes?: VariableType[];
};

export function getVariables({
  serialized,
  serializedModule,
  searchScopes,
  searchTypes
}: GetVariablesProps): VariableOption[] {
  serialized ??= window.apm.serialized;

  return [
    ...serialized.components.variables.map((variable) => {
      const { scope: scopeType } = variable.props.config;
      const scope = (scopeType === VariableScope.conversation) ? (
        VariableReferenceScope.conversation
      ) : VariableReferenceScope.application;

      return { item: variable, scope };
    }),
    ...serializedModule?.localVariables?.map((variable) => {
      const scope = VariableReferenceScope.module;

      return { item: variable, scope };
    }) ?? []
  ].map((option): VariableOption => {
    const {
      defaultValue,
      sensitiveData = false,
      type,
      varName
    } = option.item.props.config;
    const reference: VariableReference = `${option.scope}.${varName}`;

    return {
      ...option,
      defaultValue: defaultValue ?? null,
      id: option.item.id,
      item: option.item,
      label: reference,
      sensitiveData,
      type,
      value: reference
    };
  }).filter(({ scope, type }) => {
    return (
      (!searchScopes || searchScopes.includes(scope))
      && (!searchTypes || searchTypes.includes(type))
    );
  }).sort((optionA, optionB) => {
    return optionA.label.localeCompare(optionB.label);
  });
}
